<!-- Universal Popup Door -->

<template>
	<div class="shadow" @click="goClose">
		<div class="frame" ref="popFrame" @click.stop>
			<div class="header">
				<div class="title  wi8_font">
					{{popData.popTitle}}
				</div>
				<div class="close_box" @click="goClose">
					<UniIcon 
						ico="cancel"
						fit="1"
						pad="12"
						color="#C30"
					/>
				</div>
			</div>

			<!-- <div class="v-spacer" /> -->

			<div class="content" v-if="validComponent">
				<component :is="popData.compName" :compData="popData.compData"></component>
			</div>
			
			<div class="content" v-else>
				{{popData.popText}}
			</div>

		</div>
	</div>
</template>

<script>
import { m } from "@/utils/utils";
import Vue from "vue";
import { eventBus } from '@/main';
export default {
	props: {
		popData: { type: Object, default: function () {return {}} },
	},
	data() {
		return {
			validComponent: false,
		}
	},
	methods: {
		goClose() {
			m("go close");	
			this.$refs.popFrame.className = "frame hide";
			setTimeout(() => {
				eventBus.$emit("popoff");
			}, 300);
		},
		handleClose(idx) {
			m("door " + this.popData.popIdx + " handle close " + idx);
			if (idx == this.popData.popIdx) {
				m("door " + this.popData.popIdx + " closing");
				this.goClose();
			}
		},
	},

	created() {
		this.validComponent = (this.popData.compName in Vue.options.components);
		this.popData.compData = {...this.popData.compData, modal:true}; // Inject modal flag into component data
		eventBus.$on('popcloseidx', this.handleClose);
	},
	beforeDestroy() {
		eventBus.$off('popcloseidx', this.handleClose);
	},
	mounted() {
		setTimeout(() => {
			this.$refs.popFrame.className = "frame show";
		}, 100);
	}
}
</script>

<style scoped>
.shadow {
	width: 100%;
	height: 100%;
	overflow: hidden;
	/* background-color: #999; */
	/* opacity: 0.5; */
	background:rgba(100, 100, 100, .5);
	/* padding: 0px 100px 0px 0px; */
	border-radius: 8px;
	border: solid 0px #F60;
}

.frame {
	width: 250px;
	height: 100%;
	overflow: hidden;
	/* background:rgba(255, 255, 255,1); */
	opacity: 1;
	background-color: #FFF;
	border-radius: 8px;
	border-bottom-left-radius: 5px;
	border: solid 1px #999;
	border-right: solid 2px #666;

	position: relative;
	left: -410px;
	transition-duration: .3s;
	transition-timing-function: ease-in-out;
}

.show {
	transform: translateX(410px);
}


.hide {
	transform: translateX(0px);
}

.header {
	height: 60px;
	border: solid 0px #963;
}

.title {
	float:left;
	height: 55px;
	width: calc(100% - 50px);
	overflow: hidden;
	font-size: 16px; 
	/* text-align: center; */
	padding: 10px;
	border: solid 0px #999;
}

.close_box {
	float:right;
	width: 48px;
	height: 48px;
	overflow: hidden;
	cursor: pointer;
	border: solid 0px #C30;
}

.v-spacer {
	clear: both;
	width: 5px;
	height: 5px;
	border: solid 0px #000;
}

.content {
	width: 100%;
	height: calc(100% - 60px);
	overflow: hidden;
	border: solid 0px #090;
}
</style>
